// role может быть CUSTOMER, LIQUIDITY_PROVIDER, ALL (для всех ролей)

export interface OnboardingElement {
  role: string[];
  type?: ("EXPORT" | "IMPORT")[]; // тип заявки. В компоненте обработки json'а его нигде не используем. Нужный эл-нт выводится по ui_element_id
  tooltip_name?: string;
  tooltip: string;
  pages?: string[];
  ui_element_id: string;
  placement?:
    | "top"
    | "left"
    | "right"
    | "bottom"
    | "topLeft"
    | "topRight"
    | "bottomLeft"
    | "bottomRight"
    | "leftTop"
    | "leftBottom"
    | "rightTop"
    | "rightBottom";
}

export const onboardingData: OnboardingElement[] = [
  // ОБЩИЕ
  // Блок информации о пользователе
  {
    role: ["CUSTOMER", "LIQUIDITY_PROVIDER"],
    tooltip_name: "Блок информации о пользователе.",
    tooltip:
      "Здесь расположен блок информации о вашей учетной записи с возможностью редактирования параметров профиля, смены пароля.",
    pages: ["bids", "contracts", "info"],
    ui_element_id: "profile-link",
    placement: "bottomRight",
  },

  // Боковое меню (для УВЭД)
  {
    role: ["CUSTOMER"],
    tooltip_name: "Боковое меню.",
    tooltip:
      "В боковом меню расположены разделы Платформы. Здесь также будут отображаться события, ожидающие вашего действия (например, акцепт котировки).",
    pages: ["bids", "contracts", "pending-actions", "info"],
    ui_element_id: "main-menu",
    placement: "bottomLeft",
  },

  // Боковое меню (для ПЛ)
  {
    role: ["LIQUIDITY_PROVIDER"],
    tooltip_name: "Боковое меню.",
    tooltip:
      "В боковом меню расположены разделы Платформы. Здесь также будут отображаться события, ожидающие вашего действия (например, предложение котировки или перевод ЦВ).",
    pages: ["bids", "contracts", "pending-actions", "info"],
    ui_element_id: "main-menu",
    placement: "bottomLeft",
  },

  // ================================
  // Страница "Ожидают действий". Вкладка «Заявки»
  {
    role: ["CUSTOMER", "LIQUIDITY_PROVIDER"],
    tooltip_name: "Вкладка «Заявки».",
    tooltip: "Здесь отображаются все заявки, требующие от вас действий на платформе.",
    ui_element_id: "pending-actions-bids-tab",
    placement: "top",
  },

  // Страница "Ожидают действий". Фильтр по статусам заявок
  {
    role: ["CUSTOMER", "LIQUIDITY_PROVIDER"],
    tooltip:
      "Это фильтр по статусам заявок. При нажатии на нужный статус таблица отобразит заявки только в этом статусе.",
    ui_element_id: "pending-actions-bids-status-filters",
    placement: "top",
  },

  // Страница "Ожидают действий". Грид с заявками
  {
    role: ["CUSTOMER", "LIQUIDITY_PROVIDER"],
    tooltip_name: "Список заявок.",
    tooltip: "Здесь отображаются все заявки, требующие от вас действия с учетом примененных фильтров.",
    ui_element_id: "pending-actions-bids-table",
    placement: "topRight",
  },

  // Страница "Ожидают действий". Грид с заявками. Поисковая строка
  {
    role: ["CUSTOMER", "LIQUIDITY_PROVIDER"],
    tooltip: "Поле для поиска заявок по УНК, номеру заявки, также можно фильтровать заявки по их дате.",
    ui_element_id: "pending-actions-bids-search",
    placement: "topLeft",
  },

  // ================================
  // Страница "Информация". Ссылка для скачивания правил платформы
  {
    role: ["CUSTOMER", "LIQUIDITY_PROVIDER"],
    tooltip: "Ссылка для скачивания актуальных правил платформы.",
    ui_element_id: "info-rules-link",
    placement: "leftTop",
  },

  // Страница "Информация". Курс валюты
  {
    role: ["CUSTOMER", "LIQUIDITY_PROVIDER"],
    tooltip_name: "Курс валюты.",
    tooltip:
      "Индикативный курс валют, который используется при предложении котировок на покупку и продажу цифровой валюты.",
    ui_element_id: "info-currency-rate",
    placement: "topLeft",
  },

  // Страница "Информация". Блок информации
  {
    role: ["CUSTOMER", "LIQUIDITY_PROVIDER"],
    tooltip: "Блок информации о времени функционирования платформы.",
    ui_element_id: "info-time-block",
    placement: "top",
  },

  // ================================
  // Страница "Онбординг". Правила и акцепт оферты
  {
    role: ["CUSTOMER", "LIQUIDITY_PROVIDER"],
    tooltip_name: "Правила и акцепт оферты.",
    tooltip:
      "Скачайте эти документы и после ознакомления подпишите сформированную заявку на присоединение к правилам платформы. Это необходимо для проведения операций в рамках экспериментально-правового режима.",
    ui_element_id: "compliance-review-documents",
    placement: "top",
  },

  // Страница "Онбординг". Приложить документы
  {
    role: ["CUSTOMER", "LIQUIDITY_PROVIDER"],
    tooltip:
      "Подпишите заявление на присоединение к правилам платформы. Скан подписанного заявления прикрепите в отведенном для этого поле.",
    ui_element_id: "compliance-review-new-documents",
    placement: "top",
  },

  // ================================
  // Страница "Профиль пользователя". Блок "Сведения о компании"
  {
    role: ["CUSTOMER", "LIQUIDITY_PROVIDER"],
    tooltip: "Блок информации о вашей организации",
    ui_element_id: "profile-company-info",
    placement: "topLeft",
  },

  // Страница "Профиль пользователя". Банковские реквизиты
  {
    role: ["CUSTOMER", "LIQUIDITY_PROVIDER"],
    tooltip:
      "Блок банковских реквизитов вашей организации, отображаемых другим пользователям. Здесь вы можете внести несколько банковских счетов и выбрать основной из них.",
    ui_element_id: "profile-bank-details",
    placement: "bottomLeft",
  },

  // Экран «Профиль пользователя» ПЛ
  {
    role: ["LIQUIDITY_PROVIDER"],
    tooltip:
      "Адреса в блокчейн-сетях по умолчанию. Данные адреса будут автоматически указываться при обработке заявок на платформе.",
    ui_element_id: "profile-blockchain-addresses",
    placement: "topLeft",
  },
  {
    role: ["LIQUIDITY_PROVIDER"],
    tooltip: "Срок действия котировок на покупку/продажу ЦВ по умолчанию. Для изменения нажмите на значок карандаша.",
    ui_element_id: "profile-quotes-dates",
    placement: "topRight",
  },

  // ================================
  // ОСТАЛЬНЫЕ
  // Вкладка «Онбординг» - При первом входе.
  {
    // TODO
    role: ["ALL"],
    tooltip: "На каждой странице доступна кнопка «Помощь» - она отображает подсказки по основным элементам страницы",
    ui_element_id: "helpers-button",
    placement: "topRight",
  },

  // Вкладка «Договоры»
  {
    role: ["CUSTOMER"],
    tooltip_name: "Список договоров.",
    tooltip:
      "Здесь отображаются все договоры, заведенные на Платформу. Их можно фильтровать, нажав на значок лупы, и сортировать, нажав на нужный столбец.",
    ui_element_id: "contracts-table",
    placement: "topLeft",
  },

  // Вкладка «Заявки»
  {
    role: ["CUSTOMER"],
    tooltip_name: "Список заявок.",
    tooltip:
      "Здесь отображаются все заявки в рамках активных договоров. Их можно фильтровать, нажав на значок лупы, и сортировать, нажав на нужный столбец.",
    ui_element_id: "bids-table",
    placement: "topLeft",
  },
  {
    role: ["LIQUIDITY_PROVIDER"],
    tooltip_name: "Список заявок.",
    tooltip:
      "Здесь отображаются все заявки, требующие подключения к процессу поставщика ликвидности. Их можно фильтровать, нажав на значок лупы, и сортировать, нажав на нужный столбец.",
    ui_element_id: "bids-table",
    placement: "topLeft",
  },

  // ================================
  // Экран «Создание нового договора»
  {
    role: ["CUSTOMER"],
    tooltip:
      "Введите параметры договора: УНК – уникальный номер контракта, полученный в уполномоченном банке при постановке на учет, дату подписания договора с контрагентом, направление договора (Импорт или Экспорт), а также сумму и валюту договора",
    ui_element_id: "contract-unk-input",
    placement: "top",
  },
  {
    role: ["CUSTOMER"],
    tooltip: "Если в договоре нет фиксированной суммы, нажмите «Рамочный договор»",
    ui_element_id: "contract-frame-checkbox",
    placement: "topLeft",
  },
  {
    role: ["CUSTOMER"],
    tooltip:
      "Укажите данные о контрагенте: его полное наименование (если договор двуязычный, то наименование на английском языке), страну или код страны из Общероссийского классификатора стран мира",
    ui_element_id: "contract-agent-input",
    placement: "topRight",
  },
  {
    role: ["CUSTOMER"],
    tooltip: "Прикрепите скан договора, который соответствует параметрам, введенным вами выше",
    ui_element_id: "contract-document-input",
    placement: "bottom",
  },
  {
    role: ["CUSTOMER"],
    tooltip: "При нажатии «Сохранить» ваш договор поступит на проверку, которая занимает от 10 минут до 2 часов.",
    ui_element_id: "contract-save-button",
    placement: "topRight",
  },

  // ================================
  // Карточка "Договор"
  {
    role: ["CUSTOMER"],
    tooltip:
      "Блок информации о договоре. Содержит данные о вашей компании, о контрагенте по договору и параметры договора.",
    ui_element_id: "contract-info-block",
    placement: "top",
  },
  {
    role: ["CUSTOMER"],
    tooltip: "Здесь отображается текущий статус договора",
    ui_element_id: "contract-status",
    placement: "topRight",
  },
  {
    role: ["CUSTOMER"],
    tooltip: "Сверху блока информации о договоре отображается информационный блок, описывающий следующие шаги.",
    ui_element_id: "contract-action-notifier",
    placement: "topLeft",
  },
  {
    role: ["CUSTOMER"],
    tooltip: "Блок с документами договора, документы доступны для скачивания",
    ui_element_id: "contract-documents",
    placement: "topLeft",
  },
  {
    role: ["CUSTOMER"],
    tooltip: "Блок заявок на покупку/продажу цифровой валюты в рамках данного договора.",
    ui_element_id: "contract-bids",
    placement: "top",
  },
  {
    role: ["CUSTOMER"],
    tooltip:
      "Для создания новой заявки нажмите на кнопку «Подать заявку». Если сумма всех заявок уже превышает сумму договора, кнопка будет недоступна.",
    ui_element_id: "contract-create-bid-button",
    placement: "topLeft",
  },

  // ================================
  // Форма создания заявки. Поле для ввода суммы заявки
  {
    role: ["CUSTOMER"],
    type: ["EXPORT", "IMPORT"],
    tooltip:
      "Введите сумму заявки в валюте договора. Сумма не может быть больше суммы, указанной в прикрепленном скане инвойса.",
    ui_element_id: "create-bid-amount",
    placement: "right",
  },

  // Форма создания заявки. Область добавления скана инвойса
  {
    role: ["CUSTOMER"],
    type: ["EXPORT", "IMPORT"],
    tooltip: "Прикрепите скан инвойса",
    ui_element_id: "create-bid-invoice-input",
    placement: "right",
  },
  {
    role: ["CUSTOMER"],
    type: ["EXPORT", "IMPORT"],
    tooltip:
      "Нажмите кнопку «Далее» для передачи заявки на согласование. Обычно согласование заявок занимает от 10 минут до 2 часов.",
    ui_element_id: "create-bid-next-button",
    placement: "left",
  },

  // Создание «Заявка – «Экспорт»
  {
    role: ["CUSTOMER"],
    type: ["EXPORT"],
    tooltip:
      "Если ваш контрагент может отправить платеж в цифровой валюте, активируйте данный параметр, в таком случае привлечение платежного агента не потребуется. При активации потребуется ввести сумму, вид цифровой валюты и сеть блокчейн",
    ui_element_id: "create-exp-bid-without-agent-checkbox",
    placement: "left",
  },
  {
    role: ["CUSTOMER"],
    type: ["EXPORT"],
    tooltip:
      "Выберите расчётный счет, на который будут начислены денежные средства. По умолчанию выбран расчетный счет, который вы указали в настройках профиля.",
    ui_element_id: "create-bid-account-select",
    placement: "right",
  },

  // Создание «Заявка - импорт»
  {
    role: ["CUSTOMER"],
    type: ["IMPORT"],
    tooltip:
      "Если ваш контрагент может принять платеж в цифровой валюте, активируйте данный параметр, в таком случае привлечение платежного агента не потребуется. При активации потребуется ввести сумму, вид цифровой валюты, адрес криптокошелька вашего контрагента и сеть блокчейн.",
    ui_element_id: "create-imp-bid-without-agent-checkbox",
    placement: "left",
  },
  {
    role: ["CUSTOMER"],
    type: ["IMPORT"],
    tooltip:
      "Узнайте адрес криптокошелька у вашего контрагента и введите его в поле. Внимательно проверьте корректность ввода.",
    ui_element_id: "create-bid-destination-wallet-input",
    placement: "left",
  },

  // ================================
  // Страница "Заявки"

  // Подсказка с описанием шага для статуса заявки
  {
    role: ["CUSTOMER", "LIQUIDITY_PROVIDER"],
    type: ["IMPORT", "EXPORT"],
    tooltip: "Сверху блока информации о заявке отображается информационный блок, описывающий следующие шаги по заявке.",
    ui_element_id: "bid-action-notifier",
    placement: "topLeft",
  },

  // Конкретная подсказка с появляющимися реквизитами для перевода денежных средств (для УВЭД)
  {
    role: ["CUSTOMER", "LIQUIDITY_PROVIDER"],
    type: ["IMPORT", "EXPORT"],
    tooltip:
      "При нажатии на подчеркнутый текст отобразятся реквизиты для перевода денежных средств. Используйте эти данные для формирования платежного поручения в вашем онлайн-банке",
    ui_element_id: "bid-action-notifier-with-details",
    placement: "top",
  },

  // Блок "Документы" в карточке заявки
  {
    role: ["CUSTOMER", "LIQUIDITY_PROVIDER"],
    type: ["IMPORT", "EXPORT"],
    tooltip: "Все документы, сформированные на разных этапах исполнения заявки. Документы доступны для скачивания.",
    ui_element_id: "bid-documents",
    placement: "topLeft",
  },

  // Текущий статус заявки (для УВЭД)
  {
    role: ["CUSTOMER"],
    type: ["IMPORT", "EXPORT"],
    tooltip: "Текущий статус вашей заявки.",
    ui_element_id: "bid-status",
    placement: "top",
  },

  // Текущий статус заявки (для ПЛ)
  {
    role: ["LIQUIDITY_PROVIDER"],
    type: ["IMPORT", "EXPORT"],
    tooltip: "Текущий статус заявки.",
    ui_element_id: "bid-status",
    placement: "top",
  },

  // Жизненный цикл заявки (для УВЭД)
  {
    role: ["CUSTOMER"],
    type: ["IMPORT", "EXPORT"],
    tooltip_name: "Жизненный цикл заявки.",
    tooltip: "Здесь отображаются все пройденные и будущие этапы вашей заявки.",
    ui_element_id: "bid-steps",
    placement: "left",
  },

  // Жизненный цикл заявки (для ПЛ)
  {
    role: ["LIQUIDITY_PROVIDER"],
    type: ["IMPORT", "EXPORT"],
    tooltip_name: "Жизненный цикл заявки.",
    tooltip: "Здесь отображаются все пройденные и будущие этапы заявки.",
    ui_element_id: "bid-steps",
    placement: "left",
  },

  // Кнопка "Средства переведены, подписать поручение на списание ЦВ"
  {
    role: ["CUSTOMER", "LIQUIDITY_PROVIDER"],
    type: ["IMPORT", "EXPORT"],
    tooltip:
      "Подтвердите перевод средств. При нажатии этой кнопки вы перейдете к подписанию СМС-кодом поручения на перевод цифровой валюты на внешний адрес.",
    ui_element_id: "bid-sent-transfer",
    placement: "top",
  },

  // Кнопка "Отменить заявку"
  {
    role: ["CUSTOMER"],
    type: ["IMPORT", "EXPORT"],
    tooltip: "Вы можете отменить заявку до утверждения вами котировки, предложенной поставщиком ликвидности.",
    ui_element_id: "cancel-bid-draft-button",
  },

  // Заявка – импорт и экспорт (согласование агентских условий)
  {
    role: ["CUSTOMER"],
    type: ["IMPORT", "EXPORT"],
    tooltip: "Блок информации о сделке",
    ui_element_id: "bid-info-block",
    placement: "topRight",
  },

  {
    role: ["CUSTOMER"],
    type: ["IMPORT", "EXPORT"],
    tooltip:
      "После прикрепления подписанных документов при нажатии «Принять условия» вы перейдете к согласованию котировки покупки/продажи цифровой валюты.",
    ui_element_id: "accept-conditions-button",
  },

  // Заявка – импорт и экспорт (котировка предложена)
  {
    role: ["CUSTOMER"],
    type: ["IMPORT", "EXPORT"],
    tooltip:
      "Ознакомьтесь с предложенными условиями. Здесь отображается итоговая сумма покупки/продажи цифровой валюты в рублях, а также комиссия платформы.",
    ui_element_id: "bid-quote-proposed-info-block",
    placement: "topRight",
  },
  {
    role: ["CUSTOMER"],
    type: ["IMPORT", "EXPORT"],
    tooltip:
      "При нажатии «Принять условия» вы перейдете к подтверждению условий купли/продажи цифровой валюты с помощью СМС-кода",
    ui_element_id: "request-approve-button",
  },
  {
    role: ["CUSTOMER"],
    type: ["IMPORT", "EXPORT"],
    tooltip: "Вы можете отклонить предложенные условия, в таком случае вам предложат другую котировку.",
    ui_element_id: "cancel-bid-quote-proposed-button",
    placement: "right",
  },

  // Заявка – импорт и экспорт (Ожидание ЦВ)
  {
    role: ["CUSTOMER"],
    type: ["IMPORT", "EXPORT"],
    tooltip: "Сгенерированный платформой транзитный кошелек. Снизу отображается баланс.",
    ui_element_id: "bid-transit-wallet",
    placement: "top",
  },

  // Заявка импорт – экспорт («Новая заявка»)
  {
    role: ["LIQUIDITY_PROVIDER"],
    type: ["IMPORT", "EXPORT"],
    tooltip: "Блок информации о заявке, содержит сумму и вид цифровой валюты для обеспечения заявки",
    ui_element_id: "bid-new-info-block",
    placement: "topRight",
  },
  {
    role: ["LIQUIDITY_PROVIDER"],
    type: ["IMPORT", "EXPORT"],
    tooltip: "Список котировок, предложенных под конкретную заявку.",
    ui_element_id: "bid-quotes",
    placement: "top",
  },
  {
    role: ["LIQUIDITY_PROVIDER"],
    type: ["IMPORT", "EXPORT"],
    tooltip: "При нажатии на кнопку вы перейдете на экран предложения котировки покупки/продажи цифровой валюты.",
    ui_element_id: "bid-quote-button",
    placement: "right",
  },

  // ================================
  // Форма создания котировки. Срок действия котировки
  {
    role: ["LIQUIDITY_PROVIDER"],
    type: ["IMPORT", "EXPORT"],
    tooltip:
      "Срок действия котировки, в течение которого она будет доступна для одобрения. Значение по умолчанию указывается в настройках профиля.",
    ui_element_id: "create-quote-duration",
    placement: "right",
  },

  // Форма создания котировки. Снятие ограничения на время принятия условий УВЭДом
  {
    role: ["LIQUIDITY_PROVIDER"],
    type: ["IMPORT", "EXPORT"],
    tooltip: "Выберите для снятия ограничения на время принятия условий УВЭДом.",
    ui_element_id: "create-quote-duration-checkbox",
    placement: "leftTop",
  },

  // Форма создания котировки. Подписание ДКП на Цифровую валюту
  {
    role: ["LIQUIDITY_PROVIDER"],
    type: ["IMPORT", "EXPORT"],
    tooltip: "После нажатия кнопки потребуется подписать ДКП на Цифровую валюту, введя код из СМС.",
    ui_element_id: "create-quote-sign-button",
    placement: "left",
  },

  // Экран «Предложение котировки» Импорт
  {
    role: ["LIQUIDITY_PROVIDER"],
    type: ["IMPORT"],
    tooltip: "Введите котировку на продажу цифровой валюты.",
    ui_element_id: "create-imp-quote-amount",
    placement: "left",
  },
  {
    role: ["LIQUIDITY_PROVIDER"],
    type: ["IMPORT"],
    tooltip:
      "Ваш счет, на который поступят денежные средства. Вы можете выбрать из счетов, указанных в настройках профиля.",
    ui_element_id: "create-quote-bank-account-select",
    placement: "right",
  },

  // Экран «Предложение котировки» Экспорт
  {
    role: ["LIQUIDITY_PROVIDER"],
    type: ["EXPORT"],
    tooltip: "Введите котировку на покупку цифровой валюты.",
    ui_element_id: "create-exp-quote-amount",
    placement: "left",
  },
  {
    role: ["LIQUIDITY_PROVIDER"],
    type: ["EXPORT"],
    tooltip:
      "Ваш адрес кошелька, на который поступят денежные средства. Используется адрес по умолчанию для этой сети. Чтобы ввести другой адрес, снимите выбор с «Использовать кошелек по умолчанию»",
    ui_element_id: "create-quote-bank-wallet-input",
    placement: "rightTop",
  },
];
